import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiArrowRight}=FiIcons;

const Hero=()=> {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div 
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="space-y-8"
        >
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="w-64 h-64 flex items-center justify-center">
              <img 
                src="https://canv.wasacon.com/rudt-bau/_assets/media/be98d041c9972c824096f49dc08c4e70.png" 
                alt="RUDT Bau Logo" 
                className="w-full h-full object-contain" 
              />
            </div>
          </div>

          {/* Company Name */}
          <div className="space-y-4">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-gray-900">
              RUDT Bau
            </h1>
            <p className="text-xl md:text-2xl text-[#3466ad] font-semibold">
              Rohbau · Klinker · Putz
            </p>
          </div>

          {/* Claim */}
          <motion.div 
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.3}}
            className="space-y-6"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
              Solides Handwerk.<br />
              Präzision. Qualität.
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Seit über 10 Jahren realisieren wir Bauvorhaben mit höchsten Qualitätsstandards. Von Rohbau bis Pflasterarbeiten - wir sind Ihr zuverlässiger Partner.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div 
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.6}}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8"
          >
            <Link 
              to="/kontakt" 
              className="inline-flex items-center space-x-2 bg-[#3466ad] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#2a5291] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <span>Jetzt Kontakt aufnehmen</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </Link>
            <Link 
              to="/leistungen" 
              className="inline-flex items-center space-x-2 border-2 border-[#3466ad] text-[#3466ad] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#3466ad] hover:text-white transition-all duration-200"
            >
              <span>Unsere Leistungen</span>
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-[#3466ad]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-[#3466ad]/3 rounded-full blur-3xl"></div>
      </div>
    </section>
  );
};

export default Hero;